import Component from 'can/component/component';
import template from './featured-holes-header.stache';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'featured-holes-header',
    template: template,
    viewModel: {
        define: {
            data: {
                type: 'array',
                value: null,
            },
            swiperData: {
                type: 'array',
                value: null,
            },
            currentHole: {
                type: 'string',
            },
        },
        setCurrent(holeId) {
            if (!holeId) {
                return;
            }

            this.attr('currentHole', holeId);

            const hole = this.attr('swiperData')
                .serialize()
                .find((it) => it.identifier === holeId);

            if (!hole) {
                return;
            }

            dtm.trackWatchLiveFeaturedHoleClick(hole.title);
        },
    },
    events: {
        init() {
            this.mapSwiperData();
            this.viewModel.setCurrent(this.viewModel.attr('data.0.identifier'));
        },

        mapSwiperData(data) {
            const currentData = data || this.viewModel.attr('data').serialize();
            const swiperData = currentData.map(
                ({ identifier, image, title }) => ({
                    identifier,
                    image,
                    title: `Featured Hole ${title}`,
                }),
            );

            this.viewModel.attr('swiperData', swiperData);
        },
    },
});
